import ResetPassword from "./resetPassword.container";

export default ResetPassword;
